import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/mG4ZcxiedsEXYhVxzvinwx/mocap_humana_(1).webp';
const preconnectGoogleFonts = document.createElement('link');
preconnectGoogleFonts.rel = 'preconnect';
preconnectGoogleFonts.href = 'https://fonts.googleapis.com';
document.head.appendChild(preconnectGoogleFonts);
const preconnectGoogleStatic = document.createElement('link');
preconnectGoogleStatic.rel = 'preconnect';
preconnectGoogleStatic.href = 'https://fonts.gstatic.com';
preconnectGoogleStatic.crossOrigin = 'anonymous';
document.head.appendChild(preconnectGoogleStatic);
const preconnectCdn = document.createElement('link');
preconnectCdn.rel = 'preconnect';
preconnectCdn.href = 'https://cdn.magicpatterns.com';
document.head.appendChild(preconnectCdn);
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = HERO_IMAGE;
preloadHero.type = 'image/webp';
(preloadHero as any).fetchPriority = 'high';
document.head.appendChild(preloadHero);
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Outfit:wght@700;800;900&display=swap';
fontLink.media = 'print';
fontLink.onload = () => {
  fontLink.media = 'all';
};
document.head.appendChild(fontLink);
render(<App data-id="element-276" />, document.getElementById('root'));